import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';
import { cn } from '../../utils/cn';
export const ThemeToggle = ({ className }) => {
    const { isDark, toggleTheme } = useTheme();
    return (_jsx("button", { onClick: toggleTheme, className: cn('inline-flex items-center justify-center rounded-md h-9 w-9', 'text-muted-foreground hover:bg-accent hover:text-accent-foreground', 'transition-colors', className), title: isDark ? 'Világos mód' : 'Sötét mód', "aria-label": "T\u00E9ma v\u00E1lt\u00E1sa", children: isDark ? _jsx(Sun, { size: 18 }) : _jsx(Moon, { size: 18 }) }));
};
